import React, { useEffect, useState } from "react";
import { Grid, Paper } from "@mui/material";
import { DropLi } from "../../hooks";
import { useTranslation } from "react-i18next";

const InqDetails = ({ val }) => {
  const [values, setValues] = useState({});
  const { Gender } = DropLi();
  const { t } = useTranslation();

  useEffect(() => {
    if (values) {
      var _gender = Gender.find((j) => j.id === val.gender);
      setValues({ ...val, gender: _gender && _gender.label });
    }
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [val]);

  return (
    <Paper className="pt-5">
      {values && (
        <Grid container spacing={3} className="p-15 dark-color mb-10">
          <Grid item xs={12} md={4} className="d-grid">
            <span className="tx-xs tx-upp mb-5 grayMD-color grayMD-color">
              {t("InquiryId")}:
            </span>
            <span className="fs-18 fw-4 gray-color">{values.id}</span>
          </Grid>
          <Grid item xs={12} md={4} className="d-grid">
            <span className="tx-xs tx-upp mb-5 grayMD-color">
              {t("FirstName")}:
            </span>
            <span className="fs-18 fw-4 gray-color gray-color">
              {values.firstName}
            </span>
          </Grid>
          <Grid item xs={12} md={4} className="d-grid">
            <span className="tx-xs tx-upp mb-5 grayMD-color">
              {t("LastName")}:
            </span>
            <span className="fs-18 fw-4 gray-color">{values.lastName}</span>
          </Grid>
          <Grid item xs={12} md={4} className="d-grid">
            <span className="tx-xs tx-upp mb-5 grayMD-color">
              {t("Gender")}:
            </span>
            <span className="fs-18 fw-4 gray-color">{values.gender}</span>
          </Grid>
          <Grid item xs={12} md={4} className="d-grid">
            <span className="tx-xs tx-upp mb-5 grayMD-color">
              {t("Mobile")}:
            </span>
            <a
              className="link fs-18 fw-4 gray-color"
              href={`tel:${values.phone}`}
            >
              {values.phone}
            </a>
          </Grid>
          <Grid item xs={12} md={4} className="d-grid">
            <span className="tx-xs tx-upp mb-5 grayMD-color">
              {t("SourceOfInquiry")}:
            </span>
            <span className="fs-18 fw-4 gray-color">
              {values.inqSrc && values.inqSrc.name}
            </span>
          </Grid>

          <Grid item xs={12} md={4} className="d-grid">
            <span className="tx-xs tx-upp mb-5 grayMD-color">{t("City")}:</span>
            <span className="fs-18 fw-4 gray-color">
              {values.city && values.city.name}
            </span>
          </Grid>
          <Grid item xs={12} md={4} className="d-grid">
            <span className="tx-xs tx-upp mb-5 grayMD-color">
              {t("Email")}:
            </span>
            <a
              className="link fs-18 fw-4 gray-color"
              href={`mailto:${values.email}`}
            >
              {values.email}
            </a>
          </Grid>
          <Grid item xs={12} md={4} className="d-grid">
            <span className="tx-xs tx-upp mb-5 grayMD-color">
              {t("InquiryDate")}:
            </span>
            <span className="fs-18 fw-4 gray-color">{values.inqDate}</span>
          </Grid>
          <Grid item xs={12} md={6} className="d-grid">
            <span className="tx-xs tx-upp mb-5 grayMD-color">
              {t("Remark")}:
            </span>
            <span className="fs-18 fw-4 gray-color">{values.remark}</span>
          </Grid>
        </Grid>
      )}
    </Paper>
  );
};

export default InqDetails;
